import type { Range } from '@attain-apps/range'

import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Trends',
      type: 'charts',
      content: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'piSwitch',
                },
                true,
              ],
            },
            {
              '{}': {
                data: {
                  '[]': [
                    {
                      '{}': {
                        name: 'TDC Performance',
                        values: {
                          '@': 'piGroup',
                        },
                      },
                    },
                  ],
                },
                type: 'bar.stacked',
              },
            },
          ],
          {
            '{}': {
              data: {
                '[]': [
                  {
                    '{}': {
                      name: {
                        '++': [
                          {
                            '@$': 'financialVolume',
                          },
                          ' Performance',
                        ],
                      },
                      values: {
                        '@': 'organizationGroup',
                      },
                    },
                  },
                ],
              },
              type: 'bar.stacked',
            },
          },
        ],
      },
    },
  },
  variables: {
    piSwitch: false,
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
  subqueries: {
    piGroup: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              null,
            ],
          },
          {
            in: [
              {
                '[]': [
                  {
                    '@$': 'orgRecordId',
                  },
                ],
              },
              {
                '@': 'projectOrgs',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          points: {
            '[]': [
              {
                '{}': {
                  x: '2020',
                  y: {
                    '+': {
                      '@': 'expenses2020',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2021',
                  y: {
                    '+': {
                      '@': 'expenses2021',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2022',
                  y: {
                    '+': {
                      '@': 'expenses2022',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2023',
                  y: {
                    '+': {
                      '@': 'expenses2023',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2024',
                  y: {
                    '+': {
                      '@': 'expenses2024',
                    },
                  },
                },
              },
            ],
          },
        },
      },
      subqueries: {
        projects: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'projectPiAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@.': [
                      '!org',
                      {
                        ref: {
                          entity: 'ent:!org:!dept',
                        },
                      },
                    ],
                  },
                  {
                    '@$': 'orgRecordId',
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
        },
        projectOrgs: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'projectPiAssignments',
          filter: {
            '!=': [
              {
                '@': 'organizations',
              },
              {
                '[]': [],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '@': 'organizations',
          },
          subqueries: {
            organizations: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              filter: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        true,
                      ],
                    },
                    {
                      '=': [
                        {
                          '@.': '!should_analyze',
                        },
                        true,
                      ],
                    },
                  ],
                  true,
                ],
              },
              target: 'dim::!org',
              selection: {
                '@.': '!id',
              },
            },
          },
        },
        expenses2020: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2020',
              },
              start: {
                $date: '1/1/2020',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2021: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2021',
              },
              start: {
                $date: '1/1/2021',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2022: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2022',
              },
              start: {
                $date: '1/1/2022',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2023: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2023',
              },
              start: {
                $date: '1/1/2023',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2024: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projects',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2024',
              },
              start: {
                $date: '1/1/2024',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        projectPiAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    organizationGroup: {
      filter: {
        and: [
          {
            '=': [
              {
                '@^': 'parent',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    true,
                  ],
                },
                {
                  '=': [
                    {
                      '@.': '!should_analyze',
                    },
                    true,
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          points: {
            '[]': [
              {
                '{}': {
                  x: '2020',
                  y: {
                    '+': {
                      '@': 'expenses2020',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2021',
                  y: {
                    '+': {
                      '@': 'expenses2021',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2022',
                  y: {
                    '+': {
                      '@': 'expenses2022',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2023',
                  y: {
                    '+': {
                      '@': 'expenses2023',
                    },
                  },
                },
              },
              {
                '{}': {
                  x: '2024',
                  y: {
                    '+': {
                      '@': 'expenses2024',
                    },
                  },
                },
              },
            ],
          },
        },
      },
      subqueries: {
        expenses2020: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2020',
              },
              start: {
                $date: '1/1/2020',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2021: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2021',
              },
              start: {
                $date: '1/1/2021',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2022: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2022',
              },
              start: {
                $date: '1/1/2022',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2023: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2023',
              },
              start: {
                $date: '1/1/2023',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        expenses2024: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'researchType',
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          period: {
            $range: {
              end: {
                $date: '12/31/2024',
              },
              start: {
                $date: '1/1/2024',
              },
            },
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        projectAssignments: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          target: 'ent:!projects:!proj',
        },
      },
    },
  },
}
